import React from "react";
import "./Button.css";
import { CircularProgress } from "@mui/material";

const CustomButton = ({
  Text,
  PrimaryColorBtn,
  navBar,
  className = "",
  isLoading,
  ...props
}) => {
  return (
    <button
      disabled={isLoading}
      {...props}
      className={` ${className ?? ""} 
       ${isLoading ? "disable" : "not-loading"
        } ${PrimaryColorBtn
          ? "btn_bgPrimaryColor btn-primary-primary "
          : "btn  btn-primaryheader "
        } 
      ${navBar ? "btn_navbar_padding" : ""} btn-common-style`}
    >
      <p className="btn_common">
        {isLoading && (
          <CircularProgress
            sx={{ color: PrimaryColorBtn ? "#fff" : "#002E5D" }}
            size={18}
          />
        )}
        {Text} <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.44555 2.36817L7.20292 5.37132H0.748047V7.42238H7.20292L4.44555 10.4255L5.91064 12.0219L11.0732 6.39685L5.91064 0.771851L4.44555 2.36817Z" fill="CurrentColor" />
        </svg>
      </p>
    </button>
  );
};

export default CustomButton;
